module.exports = __webpack_public_path__ + "9056703894f8a6614673484d9094ba1c.png";